import { useRelatedRecords } from "../../../api/useRelatedRecords";
import { EEG_SERVICES, NFB_SERVICE } from "../../../utils/constants";
import { evaluationsFieldsQuery } from "../../evaluations/evaluationRoutes";
import { fieldsQueryArray } from "../../neurofeedback-zscore-sessions/utils";
import type { LogbookSessionItem } from "../types";

export const useSessionNFBorEEGDetailPanel = (session: LogbookSessionItem) => {
	const serviceId = session.service?.id ?? 0;
	const isEEG = EEG_SERVICES.includes(serviceId);
	const isNFB = serviceId === NFB_SERVICE;
	const isNFBorEEG = isEEG || isNFB;
	const nfbFieldsQuery = fieldsQueryArray.join(",");

	const { data: evaluationData, status: evalStatus } = useRelatedRecords("evaluations", evaluationsFieldsQuery, "eeg_session", isEEG ? session.id : null);
	const { data: nfbData, status: nfbStatus } = useRelatedRecords("neurofeedback_data", nfbFieldsQuery, "session", isNFB ? session.id : null);

	const evaluationItem = evaluationData?.items?.[0];
	const nfbItem = nfbData?.items?.[0];

	const specializedStatus = isEEG ? evalStatus : isNFB ? nfbStatus : "idle";
	const specializedResolved = specializedStatus === "success";
	const isNFBorEEGLoading = isNFBorEEG ? !specializedResolved : false;

	return { isNFBorEEGLoading, evaluationItem, nfbItem };
};
